<template>
    <ui-dropdown placement="bottom-start" :menu-class="menuClass" trigger-class="flex-1" :enabled="enabled"
                 @opened="opened"
                 ref="dropdown">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 max-h-64 overflow-y-auto w-full z-30">
                <div class="space-y-6">
                    <div v-if="results.length > 0">
                        <div class="flex text-xs font-medium text-gray-400 mb-1">
                            <div class="ml-2 flex-grow">Resource Planning Report Materials</div>
                            <div class="flex-shrink mr-4">Still Required</div>
                        </div>
                        <div class="space-y-1">
                            <div
                                v-for="section in results"
                                class="flex space-x-2 text-left w-full text-gray-500 pl-2 pr-0 py-0"
                                :title="section.name"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full flex py-1">
                                        <div class="flex-shrink truncate" v-text="section.name"></div>
                                        <div
                                            class="ml-1 flex-grow hover:text-blue-400 cursor-pointer text-gray-300"
                                            @mousedown="$emit('addMaterials', addSection(section));">
                                            <span class="fa fa-plus text-xs opacity-100"></span> all
                                        </div>
                                    </div>
                                    <div
                                        v-for="task in section.tasks"
                                        class="space-x-2 text-left w-full pl-2 pr-0 py-0"
                                    >
                                        <div class="truncate flex-1 flex flex-col">
                                            <div class="truncate w-full flex py-1">
                                                <div class="flex-shrink truncate"
                                                     v-text="task.reference+' - '+task.name"></div>
                                                <div
                                                    class="ml-1 flex-grow hover:text-blue-400 cursor-pointer text-gray-300"
                                                    @mousedown="$emit('addMaterials', addTask(section,task))">
                                                    <span class="fa fa-plus text-xs opacity-100"></span> all
                                                </div>
                                            </div>
                                            <div
                                                v-for="item in task.items"
                                                class="flex space-x-2 text-left w-full pl-2 pr-0 py-0"
                                                :title="item.reference+' - '+item.name"
                                            >
                                                <div class="truncate flex-1 flex flex-col">
                                                    <div class="truncate w-full flex py-1">
                                                        <div class="flex-shrink truncate"
                                                             v-text="item.reference+' - '+item.name"></div>
                                                        <div
                                                            class="ml-1 flex-grow hover:text-blue-400 cursor-pointer text-gray-300"
                                                            @mousedown="$emit('addMaterials', addItem(section,task,item))">
                                                            <span class="fa fa-plus text-xs opacity-100"></span> all
                                                        </div>
                                                    </div>
                                                    <div
                                                        v-for="material in item.materials"
                                                        class="flex space-x-2 text-left w-full rounded-md px-1 py-0 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                                        :title="material.name"
                                                    >
                                                        <div class="truncate flex-1 flex flex-col text-blue-500">
                                                            <div class="truncate w-full">
                                                                <div class="truncate text-sms mx-0 py-0.5 pl-1 pr-0">
                                                                    <button
                                                                        @mousedown="$emit('updateMaterials', addMaterial(material,section,task,item)); close()"
                                                                        class="flex truncate pl-1 pr-0 py-1.5 -my-0.5 border border-transparent rounded-lg text-xs w-full text-left font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 hover:text-gray-600"
                                                                    >
                                                <span class="flex-1 flex flex-grow mx-1 relative truncate">
                                                    <span class="flex-grow truncate">
                                                {{ material.name }}
                                                    <span v-if="material.unitOfMeasure"
                                                          class="italic"> - ({{ material.unitOfMeasure }})</span>
                                                    </span>
                                                    <span class="flex-shrink" v-if="material.required"
                                                          v-text="math.format(material.required,{precision:14})">
                                                    </span>
                                                </span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="(results.length ===0)" class="text-gray-500 text-sm">
                        No matching materials found.
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

import {ProjectDeliveryRequestForMaterials as RequestForMaterials} from "@models";
import UiDropdown from "../../ui/UiDropdown.vue";
import * as math from "mathjs";

export default {
    components: {UiDropdown},
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
        menuClass: {
            type: String,
            default: 'w-full',
        },
        enabled: true,
        requestForMaterials: RequestForMaterials,
        requestForMaterialItem: Object,
        resourcePlanningReport: Object,
    },
    data() {
        return {
            rpr: Object,
            results: [],
            fullTree: [],
            math
        }
    },
    watch: {
        "RequestForMaterials.packageReference": {
            handler(newValue, oldValue) {
                this.buildTree()
            },
        },
    },
    computed: {},
    methods: {
        addSection(section) {
            let adds = [];
            this.fullTree.find((i) => i.id === section.id).tasks.forEach(task => {
                adds.push(...this.addTask(section, task));
            })
            return adds;
        },
        addTask(section, task) {
            let adds = [];
            this.fullTree.find((i) => i.id === section.id).tasks.find((i) => i.id === task.id).items.forEach(item => {
                adds.push(...this.addItem(section, task, item))
            })
            return adds
        },
        addItem(section, task, item) {
            let adds = [];
            this.fullTree.find((i) => i.id === section.id).tasks.find((i) => i.id === task.id).items.find((i) => i.id === item.id).materials.forEach(material => {
                adds.push(...this.addMaterial(material, section, task, item));
            })
            return adds;
        },
        addMaterial(material, section, task, item) {
//            console.log(material,(material.required - material.requested))
//            let match = this.requestForMaterials.items.find((i) => i.itemReference && i.itemReference.item.id === item.id && i.material.trim() === material.name.trim() && i.uom === material.unitOfMeasure)
//            if (!match || (match.quantity < (material.required - material.requested))) {
            return [{material, section, task, item}];
//            }
//            return [];
        },
        matchMaterial(materialItem, section, task, item) {
            const query = ('' + this.requestForMaterialItem.material).toLowerCase().split(/[^A-Za-z0-9.-]+/);
            return query.every((token) => {
                return (section.name + ' ' + task.reference + ' ' + task.name + ' ' + item.reference + ' ' + item.description + ' ' + materialItem.name).toLowerCase().includes(token)
            });
        },
        scope(dropdownScope) {
            return {
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        addToTree(tree, section, task, item, material) {
            let match = this.requestForMaterials.items.filter((i) => i.itemReference && (i.itemReference.item.id === item.id) && (i.material.trim() === material.name.trim()) && (i.uom.trim() === material.unitOfMeasure.trim()))
            let quant = match.reduce((a, b) => math.add(a, b.quantity), 0)
            if (!match.length || (quant < (material.required - material.requested))) {
                let s = tree.find((i) => i.id === section.id);
                if (!s) {
                    s = {id: section.id, name: section.name, tasks: []}
                    tree.push(s);
                }
                let t = s.tasks.find((i) => i.id === task.id);
                if (!t) {
                    t = {id: task.id, name: task.name, reference: task.reference, items: []}
                    s.tasks.push(t);
                }
                let i = t.items.find((i) => i.id === item.id);
                if (!i) {
                    i = {id: item.id, name: item.description, reference: item.reference, materials: []}
                    t.items.push(i);
                }
                let m = i.materials.find((ii) => (ii.name.trim() === material.name.trim()) && (ii.unitOfMeasure.trim() === material.unitOfMeasure.trim()));
                if (!m) {
                    m = {name: material.name.trim(), unitOfMeasure: material.unitOfMeasure.trim(), required: 0}
                    i.materials.push(m);
                }
                m.required = math.subtract(material.required, material.requested)
                if (match.length && quant > 0) {
                    m.required = math.subtract(m.required, quant)
                }
            }
        },
        buildFullTree() {
            let tree = [];
            if (this.resourcePlanningReport) {
                this.resourcePlanningReport.sections.filter((i) => !i.omitted).forEach(section => {
                    section.tasks.filter((i) => !i.omitted).forEach(task => {
                        task.items.filter((i) => !i.omitted).forEach(item => {
                            item.materials.forEach(material => {
                                this.addToTree(tree, section, task, item, material);
                            })
                        })
                    })
                })
            }
            this.fullTree = tree;
        },
        buildTree() {
            let matches = [];
            if (this.resourcePlanningReport) {
                this.resourcePlanningReport.sections.filter((i) => !i.omitted).forEach(section => {
                    section.tasks.filter((i) => !i.omitted).forEach(task => {
                        task.items.filter((i) => !i.omitted).forEach(item => {
                            item.materials.forEach(material => {
                                if (this.matchMaterial(material, section, task, item)) {
                                    this.addToTree(matches, section, task, item, material);
                                }
                            })
                        })
                    })
                })
            }
            matches.forEach((section) => {
                section.tasks.forEach(task => {
                    task.items.forEach(item => {
                        item.materials.sort((a, b) => b.required - a.required);
                    })
                })
            })
            this.results = matches;
        },
        async setQuery(query, open = true) {
            this.buildTree()
            if (open) {
                this.$refs.dropdown.close();
                this.$refs.dropdown.open();
            }
        },
        clear(close) {
            close();
        },
        close() {
            this.$refs.dropdown.close();
        },
        opened() {
            this.buildFullTree();
            this.buildTree()
        },
        focus() {
            this.$refs.searchInput.focus();
        },
    },
    async mounted() {
        this.buildTree()
        this.buildFullTree()
    },
    beforeDestroy() {
        this.$refs.dropdown.close();
    }
}
</script>
